"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _common = require("@scuf/common");

var _routes = _interopRequireDefault(require("../common/routes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// eslint-disable-next-line react/prefer-stateless-function
var AppFooter = /*#__PURE__*/function (_Component) {
  _inherits(AppFooter, _Component);

  var _super = _createSuper(AppFooter);

  function AppFooter() {
    _classCallCheck(this, AppFooter);

    return _super.apply(this, arguments);
  }

  _createClass(AppFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          history = _this$props.history,
          footerItems = _this$props.footerItems;
      return /*#__PURE__*/_react["default"].createElement(_common.Footer, null, /*#__PURE__*/_react["default"].createElement(_common.Footer.Item, {
        href: "https://www.honeywell.com/terms-conditions",
        target: "_blank"
      }, "Terms & Conditions"), /*#__PURE__*/_react["default"].createElement(_common.Footer.Item, {
        href: "https://www.honeywell.com/privacy-statement",
        target: "_blank"
      }, "Privacy Policy"), /*#__PURE__*/_react["default"].createElement(_common.Footer.Item, {
        href: "https://www.honeywellaidc.com/working-with-us/patents",
        target: "_blank"
      }, "Patents"), /*#__PURE__*/_react["default"].createElement(_common.Footer.Item, {
        href: "https://www.honeywell.com/us/en/cookie-notice",
        target: "_blank"
      }, "Cookie Notice"), /*#__PURE__*/_react["default"].createElement(_common.Footer.Item, {
        href: "https://honeywellhub.secure.force.com/PrivacyInformationRequestForm?lang=en",
        target: "_blank"
      }, "Do Not Sell My Personal Information"), /*#__PURE__*/_react["default"].createElement(_common.Footer.Item, {
        onClick: function onClick() {
          history.push(_routes["default"].ThirdPartyLicenses);
        }
      }, "Third Party Licenses"), footerItems);
    }
  }]);

  return AppFooter;
}(_react.Component);

AppFooter.propTypes = {
  history: _propTypes["default"].shape({
    push: _propTypes["default"].func
  }).isRequired,
  footerItems: _propTypes["default"].arrayOf(_propTypes["default"].element)
};
AppFooter.defaultProps = {
  footerItems: [/*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)]
};

var _default = (0, _reactRouterDom.withRouter)(AppFooter);

exports["default"] = _default;